export default {"src":"/_next/static/media/linkedin.ad3a5c95.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};